/** Assign each segment a stable accent color from the mock's palette.
 * Segment names are client-specific, so colors are keyed by first-seen
 * order (deterministic within a report render) rather than by name. */
const PALETTE = ['#2A5F5A', '#4A5D3D', '#2E3F5F', '#B8622E', '#7A2E2E', '#3D5A5D', '#5F4A2E'];

const _order: string[] = [];

/** Stable accent color for a segment name (assigned on first encounter). */
export function segmentColor(name: string): string {
  const key = (name || '').trim();
  if (!key) return PALETTE[0];
  let i = _order.indexOf(key);
  if (i === -1) {
    i = _order.length;
    _order.push(key);
  }
  return PALETTE[i % PALETTE.length];
}
